/* src/app/main/imprint/imprint.component.scss */
.imprint p {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  font-size: medium;
}
/*# sourceMappingURL=imprint.component.css.map */
